import { AddTicketCardProps } from './types';
import { FC } from 'react';
import { Icon } from 'features/common/components/Icon';
import { useTranslation } from 'react-i18next';
import styles from './TicketTypeCard.module.css';

export const AddTicketTypeCard: FC<AddTicketCardProps> = ({ onClick }: AddTicketCardProps) => {
	const { t } = useTranslation();

	return (
		<button className={styles.addCardContainer} onClick={onClick} type="button" data-cy="add-ticket-card">
			<div className={styles.addCardContent}>
				<Icon iconName="plus" color="brightness(0)" className={styles.addIcon} />
				<div className={styles.addText}>{t('ticketDetails-ticket-add-new')}</div>
			</div>
		</button>
	);
};
